import GlobalSearchState, { MultiSearch, GlobalSearchMode } from "../typings";
import DropdownBase, { DropdownBaseProps } from "./common/DropdownBase";

export default class SearchSwitcher extends DropdownBase<DropdownBaseProps> {

	public get selectedItem(): MultiSearch {
		return this.toggleButton.val();
	}

	public set selectedItem(value: MultiSearch) {
		this.toggleButton.val(value);
	}

	constructor(state: GlobalSearchState) {
		super({
			buttons: [{
				text: MultiSearch.CCC,
				selected: state.selectedSideItemValue == MultiSearch.CCC,
				action: () => this.hideOnClick(() => {
					state.selectedSideItemValue = MultiSearch.CCC;
					state.searchMode = state.userSearchMode;
					this.updateToggleText(MultiSearch.CCC);
					state.handlers.sideItemChanged(MultiSearch.CCC);
				})
			},
			{
				text: MultiSearch.EDS,
				selected: state.selectedSideItemValue == MultiSearch.EDS,
				action: () => this.hideOnClick(() => {
					state.selectedSideItemValue = MultiSearch.EDS;
					state.searchMode = GlobalSearchMode.Default;
					this.updateToggleText(MultiSearch.EDS);
					state.handlers.sideItemChanged(MultiSearch.EDS);
				})
			}],
			id: "rfe-searchSwitcher"
		});
	}

	protected renderContainerInternal(): JQuery {
		return $("<div>")
			.addClass("rup-global-search__dropdown");
	}
}